export const KBA_EXPIRE_SEC = 300;
